import Navbar from './components/Navbar';
import AnchorMenu from './components/AnchorMenu';
import Hero from './components/Hero';
import Numbers from './components/Numbers';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import AboutUs from './components/AboutUs';
import Clients from './components/Clients';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import MobileCta from './components/MobileCta';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <AnchorMenu />
      <main>
        <Hero />
        <Numbers />
        <Services />
        <HowItWorks />
        <AboutUs />
        <Clients />
        <Faq />
        <Contact />
      </main>
      <Footer />
      {/* Mobile fixed bottom CTA — hidden on desktop */}
      <MobileCta />
    </div>
  );
}
